/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PatientsInfoSidePanel.vue?vue&type=template&id=857341c0&scoped=true"
import script from "./PatientsInfoSidePanel.vue?vue&type=script&lang=js"
export * from "./PatientsInfoSidePanel.vue?vue&type=script&lang=js"
import style0 from "./PatientsInfoSidePanel.vue?vue&type=style&index=0&id=857341c0&scoped=true&lang=css"
import style1 from "./PatientsInfoSidePanel.vue?vue&type=style&index=1&id=857341c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857341c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('857341c0')) {
      api.createRecord('857341c0', component.options)
    } else {
      api.reload('857341c0', component.options)
    }
    module.hot.accept("./PatientsInfoSidePanel.vue?vue&type=template&id=857341c0&scoped=true", function () {
      api.rerender('857341c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/PatientsInfoSidePanel.vue"
export default component.exports